var freeProductRemove = JSON.parse(sessionStorage.getItem("freeProductRemove")) || [];

// Splide init
function mmInitSplide() {
	const id = ".mm-splide-crossell";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: "slide",
			autoplay: false,
			arrows: false,
			height: "100%",
			pagination: false,
			rewind: false,
			fixedWidth: 202,
			direction: "ttb",
		}).mount();
	}
}

function mmInitSplideMobile() {
	const idMob = ".mm-splide-crossell-mobile";
	const splideElemMob = document.querySelector(idMob);

	if (splideElemMob) {
		new Splide(splideElemMob, {
			type: "slide",
			autoplay: false,
			arrows: false,
			height: "100%",
			pagination: false,
			rewind: true,
			gap: 10,
			fixedWidth: 280,
			padding: { left: 45, right: 45 },
			breakpoints: {
				768: { fixedWidth: 260, padding: { left: 18, right: 18 } },
			},
		}).mount();
	}
}

document.addEventListener(
	"DOMContentLoaded",
	() => {
		mmInitSplide();
		mmInitSplideMobile();
	},
	{ once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function mmDebounce(func, duration) {
	let timeout;
	console.log("debounce", func, duration);
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}


// NOUVEAU PANIER
function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(line_index) {
    return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}

function mmCartItemQuantityEl(line_index) {
    const itemEl = mmCartItem(line_index);

	console.log('itemel', itemEl)

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(line_index) {
    // const itemEl = mmCartItem(line_index);
    const quantityEl = mmCartItemQuantityEl(line_index);

	console.log('getcartiem')

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(line_index, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(line_index);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartItemFree(productVariantId) {
	return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartHTMLFromData(data) {
	const el = document.createElement("DIV");
	el.innerHTML = data.sections["mm-cart"];

	console.log('inner1')

	return el;
}

function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

	console.log('inner2')


	return data;
}

function extractTotalPriceFromCartHTML(data, elem) {
	const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
	return cartEl.querySelector(elem);
}

// function insertInsertTotalPriceFromResponse(data) {
// 	const newTotalPriceEl = extractTotalPriceFromCartHTML(data, "[data-cart-total-price]");
// 	const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
// 	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

// 	console.log('inner3')

// 	const newTotalPriceReductionEl = extractTotalPriceFromCartHTML(data, "[data-cart-total-price-original]");
// 	const currentTotalPriceReductionEl = mmCartSectionElement().querySelector("[data-cart-total-price-original]");
// 	currentTotalPriceReductionEl.outerHTML = newTotalPriceReductionEl.outerHTML;
// 	return data;
// }

function insertCartProductUpsellFromResponse(data) {
	if (mmCartSectionElement().querySelector(".mm-splide-crossell ul")) {
		mmCartSectionElement().querySelector(".mm-splide-crossell ul").innerHTML = mmCartHTMLFromData(data).querySelector(".mm-splide-crossell ul").innerHTML;

		console.log('inner4')

	}
	mmInitSplide();
	mmInitSplideMobile();
	return data;
}


// TEST Ouvrir et refresh le panier (utilisé pour faire fonctionner les babybox et superbox avec le panier)
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;

		console.log('inner5')


        const newCartInner = newCartEl.querySelector(".mm-drawer-cart-filter");
        const currentCartInner = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");

        if (newCartInner && currentCartInner) {
            currentCartInner.innerHTML = newCartInner.innerHTML;
        }

		console.log('TEST')

        // Réinitialiser les éléments dynamiques après le rafraîchissement
        mmInitSplide();
        mmInitSplideMobile();
        // mmInitSplideTestimonials();
        // rebindSellingPlanToggles(); // <--- Assure-toi de réinitialiser les abonnements

        document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
        document.querySelector("html").classList.add("stop-scrolling");
    }

    const rootUrl = document.querySelector(".mm-drawer-cart-filter")?.dataset.localization || '/';
    const url = rootUrl === '/' ? '/?section_id=mm-cart' : `${rootUrl}/?section_id=mm-cart`;

    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", url, true);
    request.send();
}





function mmAPIRequest(method, path, body) {
	document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");

	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	})
		.then((response) => response.json())
		.then((data) => {
			document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
			updateCartCount(data.item_count != null ? data.item_count : 0);
			if (data.status && data.status > 400) {
				throw data;
			} else {
				return data;
			}
		})
}

// récupérer le panier
function mmGetCart() {
	mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
	document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
	document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
}


// Re-render cart inner HTML from response
function refreshCartFromData(data) {
	const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = (data.sections && data.sections["mm-cart"]) || "";

	const sectionEl = mmCartSectionElement();
	const innerCart = sectionEl ? sectionEl.querySelector(".mm-drawer-cart-filter") : null;
	const newInnerCart = newCartEl.querySelector(".mm-drawer-cart-filter");
	if (innerCart && newInnerCart) {
		innerCart.innerHTML = newInnerCart.innerHTML;
	} else {
		console.error("refreshCartFromData: contenu du panier introuvable", { hasSection: !!sectionEl, hasNewInner: !!newInnerCart, sections: data.sections });
	}

	// 🔄 Mettre à jour le compteur avec fallback
	const countEl = newCartEl.querySelector("[data-cart-count]");
	if (countEl) {
		const itemCount = parseInt(countEl.dataset.cartCount, 10);
		updateCartCount(itemCount);

		// Nettoyer la liste des produits gratuits supprimés si le panier est vide
		if (itemCount === 0) {
			mmClearFreeProductRemove();
		}
	} else if (typeof data.item_count !== "undefined") {
		// 🔁 Fallback si aucun data attribute n'est trouvé
		updateCartCount(data.item_count);

		// Nettoyer la liste des produits gratuits supprimés si le panier est vide
		if (data.item_count === 0) {
			mmClearFreeProductRemove();
		}
	} else {
		console.warn("Impossible de trouver le compteur");
	}

	// Vérifier et forcer la suppression des produits gratuits si nécessaire
	mmForceRemoveFreeProductsIfCartEmpty();

	mmInitSplide();
	mmInitSplideMobile();
}


// Check product cart
function mmShowCheckmark(buttonElement) {
    // Affiche le SVG
    const iconContainer = buttonElement.querySelector('svg')?.parentElement;
    if (iconContainer) {
        iconContainer.classList.remove('mm-none');
        iconContainer.classList.add('mm-flex');
    }

    // Masque le texte "Ajouter"
    const addText = buttonElement.querySelector('.mm-product-card-add');
    if (addText) {
        addText.classList.add('mm-none');
    }

    // Affiche le texte "Ajouté"
    const addedText = buttonElement.querySelector('.mm-product-card-added');
    if (addedText) {
        addedText.classList.remove('mm-none');
    }
}



// Ajouter un item au panier
// Quantité à ajouter pour la variante sélectionnée sur la fiche produit :
// 2 si la variante a le métafield custom.double_ajout_produit = true, sinon 1.
function mmSelectedProductQty() {
	const el = document.querySelector("#product_id");
	return el && el.dataset.doubleAjout === "true" ? 2 : 1;
}

function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
	const selling_plan_id = document.querySelector("#mmSellingPlanId")?.value;
	
	// Vérifier si l'option subscription est sélectionnée (plus fiable que la classe CSS)
	const subscriptionInput = document.querySelector('input[name^="purchase_option"][value="subscription"]:checked');
	const isSubscriptionSelected = subscriptionInput !== null && selling_plan_id;

	const item = {
		quantity: quantity,
		id: productId,
	};

	if (isSubscriptionSelected) {
		item.selling_plan = selling_plan_id;
		console.log('Ajout au panier avec plan d\'abonnement:', selling_plan_id);
	} else {
		console.log('Ajout au panier sans plan d\'abonnement. Subscription checked:', subscriptionInput !== null, 'Plan ID:', selling_plan_id);
	}

	// Nettoyer la liste des produits gratuits supprimés quand on ajoute un produit
	mmClearFreeProductRemove();

	mmAPIRequest("POST", "cart/add.js", {
		items: [item],
		sections: "mm-cart",
	})
		.then((data) => {
			mmAddOrRemoveFreeProducts(data);
			refreshCartFromData(data);

			if (data.item_count !== undefined) {
				updateCartCount(data.item_count);
			}

			triggerTracking();

			if (openCart) {
				setTimeout(mmOpenCart);
			}
		})
		.catch((error) => {
			mmCartProductsContainerElement().innerHTML = `
				Oups, il y a eu une erreur, essayez de recharger la page !
			`;
			mmOpenCart();
			console.error("Erreur d'ajout au panier :", error);
		});
}

// Ajouter un item au panier et rediriger vers le checkout
function mmAddProductToCartThenRedirectToCheckout(productId, { quantity = 1, openCart = true }) {
	const selling_plan_id = document.querySelector("#mmSellingPlanId")?.value;
	
	// Vérifier si l'option subscription est sélectionnée (plus fiable que la classe CSS)
	const subscriptionInput = document.querySelector('input[name^="purchase_option"][value="subscription"]:checked');
	const isSubscriptionSelected = subscriptionInput !== null && selling_plan_id;

	const item = {
		quantity: quantity,
		id: productId,
	};

	if (isSubscriptionSelected) {
		item.selling_plan = selling_plan_id;
	}

	mmAPIRequest("POST", "cart/add.js", {
		items: [item],
		sections: "mm-cart",
	})
		.then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {
			triggerTracking();
			window.location.href = "/checkout";
		})
		.catch((error) => {
			mmCartProductsContainerElement().innerHTML = `
				Oups, il y a eu une erreur, essayez de recharger la page !
			`;
			console.log('inner10')

			mmOpenCart();
			console.log(error);
		});
}

function mmIncreaseProductQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

function mmDecreaseProductQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    const newQuantity = quantity > 0 ? quantity - 1 : 0;
    mmSetCartItemQuantity(line_index, newQuantity);
    mmDebouncedPushNewQuantity(line_index);
}

function mmDestroyProductFromCart(line_index, isfreeProduct, productVariantId) {
    // Supprimer directement l'élément du panier
    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: "mm-cart",
    })
    .then((data) => {
        // Si c'est un produit gratuit, l'ajouter à la liste des supprimés
        if (isfreeProduct && productVariantId) {
            let freeProductRemove = JSON.parse(sessionStorage.getItem("freeProductRemove")) || [];
            if (!freeProductRemove.includes(productVariantId)) {
                freeProductRemove.push(productVariantId);
                sessionStorage.setItem("freeProductRemove", JSON.stringify(freeProductRemove));
            }
        }

        // Vérifier et ajuster les produits gratuits après suppression
        mmAddOrRemoveFreeProducts(data);

        // Rafraîchir le panier
        refreshCartFromData(data);
    })
    .catch((error) => {
        console.error("Erreur lors de la suppression du produit:", error);
        location.reload();
    });
}

function mmPushNewQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);

    mmAPIRequest("POST", "cart/change.js", {
        line: line_index,
        quantity: quantity,
        sections: "mm-cart",
    })
    .then((data) => {
        // Si la quantité est 0, c'est une suppression
        if (quantity === 0) {
            // Nettoyer la liste des produits gratuits supprimés si le panier est vide
            if (data.item_count === 0) {
                mmClearFreeProductRemove();
            }
        }

        mmAddOrRemoveFreeProducts(data);  // Vérifie les produits gratuits après mise à jour
        refreshCartFromData(data);
    })
    .catch((error) => {
        console.error("Erreur lors de la mise à jour de la quantité:", error);
        location.reload();
    });
}

const mmDebouncedPushNewQuantity = debounce(function (line_index) {
    mmPushNewQuantity(line_index);
}, 300);

function mmDestroyLineItemFromCart(line_index) {

    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index),
        quantity: 0,
        sections: "mm-cart",
    })
    .then(refreshCartFromData);
}

function mmDestroyLineItemsFromCart(line_index_1, line_index_2) {

    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index_1),
        quantity: 0,
        sections: "mm-cart",
    })
    .then(() => {
      return mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index_2),
        quantity: 0,
        sections: "mm-cart",
      })
    })
    .then(refreshCartFromData);
}

function mmAddOrRemoveFreeProducts(data) {
    if (data.sections["mm-cart"]) {
        const el = mmCartHTMLFromData(data);
        const freeProductEls = el.querySelector("[data-free-products]");

        if (!freeProductEls) return data;

        // Vérifier si le panier contient des produits payants
        const hasPaidProducts = Array.from(el.querySelectorAll("[data-cart-item-id]")).some(itemEl => {
            // Vérifier si c'est un produit gratuit
            const isFreeProduct = itemEl.hasAttribute('data-free-product') ||
                                 itemEl.classList.contains('mm-dc-product-cart-free');

            if (isFreeProduct) {
                return false; // C'est un produit gratuit, ne pas le compter comme payant
            }

            const priceEl = itemEl.querySelector(".mm-dc-right-price");
            if (priceEl) {
                const priceText = priceEl.textContent.trim();
                return !priceText.includes("GRATUIT") && !priceText.includes("FREE");
            }
            return true; // Si on ne peut pas déterminer, on considère comme payant
        });

        // Liste des produits gratuits à gérer
        const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
            const productId = freeProductEl.dataset.productId;
            const isFree = freeProductEl.dataset.freeProduct == "true";
            const itemEl = mmCartItemFree(productId);
            const freeProductRemove = JSON.parse(sessionStorage.getItem("freeProductRemove")) || [];
            const isfreeProductRemove = freeProductRemove.includes(parseInt(productId));

            // Si le produit gratuit est dans le panier mais ne devrait plus être gratuit
            if (itemEl && !isFree) {
                param[productId] = 0;
            }
            // Si le produit gratuit n'est pas dans le panier mais devrait être gratuit
            else if (!itemEl && isFree && hasPaidProducts && !isfreeProductRemove) {
                param[productId] = 1;
            }
            // IMPORTANT: Si le produit gratuit est dans le panier mais qu'il n'y a plus de produits payants
            else if (itemEl && isFree && !hasPaidProducts) {
                param[productId] = 0;
            }

            return param;
        }, {});

        // Ajouter ou supprimer les produits gratuits uniquement si nécessaire
        if (Object.keys(productsParams).length > 0) {
            mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: "mm-cart" })
                .then(refreshCartFromData);
        }
    }
    return data;
}



// Ouvrir le panier pour fidelité yotpo
function mmOpenCartYotpo() {
	mmAPIRequest("POST", "cart/change.js", {
    })
    .then((data) => {
        refreshCartFromData(data);
    })
    .catch((error) => {
        location.reload();
    });

	document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
}



// PROGRESS BAR
function mmProgressBar() {}

// bubble cart count
function updateCartCount(value) {
	const countEl = document.querySelector(".mm-cart-count-bubble");

	if (!countEl) {
		console.warn("Élément .mm-cart-count-bubble introuvable !");
		return;
	}

	if (value > 0) {
		countEl.classList.remove("mm-none");
		countEl.innerText = `${value}`;
	} else {
		countEl.classList.add("mm-none");
		countEl.innerText = "";
	}
}


//Show selling plan
function toggleSellingPlan(checkbox){
	const productCard = checkbox.closest(".mm-dc-product-container");
	const subContainer = checkbox.closest(".mm-dc-cart-item-subscribe-container");
	const subSelectContainer = subContainer.querySelector(".mm-dc-select-selling-plan-container");
	const line = parseInt(subContainer.dataset.itemLine);

	if (checkbox.checked) {
	  const selling_plan = subSelectContainer.querySelector('select').value;
	  subSelectContainer.classList.remove('hidden')
	  updateSellingPlan(line, productCard, selling_plan);

	} else {
	  subSelectContainer.classList.add("hidden");
	  updateSellingPlan(line, productCard, null);
	}
  }

  //Change Selling Plan
  function updateSellingPlan(line, productCard, sellingPlan) {

	console.log('sellingplan',line, productCard, sellingPlan )

	const quantityElement = productCard.querySelector("[data-item-quantity]");
	const quantity = quantityElement ? parseInt(quantityElement.dataset.itemQuantity) : 1;

	// Objet attendu par Shopify
	let payload = {
	  line: line, // Ligne dans le panier
	  quantity: quantity,   // Quantité de la ligne
	  selling_plan: sellingPlan // Null ou ID du plan
	};


	mmAPIRequest("POST", "cart/change.js", payload)
	  .then(mmOpenAndRefreshCart)
	  .catch((error) => {
		mmCartProductsContainerElement().innerHTML = `
			Oups, il y a eu une erreur, essayez de recharger la page !
		`;
		console.log("Erreur API Shopify:", error);
	  });
  }

  window.addEventListener("DOMContentLoaded", (event) => {
	  mmGetCart();
  });


  // Ajout free product FORCE
function mmForceAddFreeProduct() {
  setTimeout(function() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const freeProductDiv = document.querySelector("[data-free-products] div[data-free-product='true']");
        if (freeProductDiv) {
          const variantId = parseInt(freeProductDiv.dataset.productId);
          const hasNormalProduct = cart.items.some(item => item.id != variantId);
          const alreadyInCart = cart.items.some(item => item.id == variantId);
          const freeProductRemove = JSON.parse(sessionStorage.getItem("freeProductRemove")) || [];
          const isfreeProductRemove = freeProductRemove.includes(variantId);

          if (hasNormalProduct && !alreadyInCart && !isfreeProductRemove) {
            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            }).then(() => {
              location.reload();
            });
          }
        }
      });
  }, 500);
}

document.addEventListener("DOMContentLoaded", mmForceAddFreeProduct);

// Nettoyer la liste des produits gratuits supprimés quand le panier est vidé
function mmClearFreeProductRemove() {
    sessionStorage.removeItem("freeProductRemove");
}

// Forcer la suppression des produits gratuits si le panier est vide
function mmForceRemoveFreeProductsIfCartEmpty() {
    fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
            if (cart.item_count === 0) {
                // Le panier est vide, nettoyer la liste des produits gratuits supprimés
                mmClearFreeProductRemove();
            }
        })
        .catch(error => console.error("Erreur lors de la vérification du panier:", error));
}
